(() => {
  document.querySelectorAll('.sw-slideshow2').forEach((root) => {
    const slides = Array.from(root.querySelectorAll('.sw-slideshow2__slide'));
    if (slides.length < 2) return;

    const prevBtn = root.querySelector('.sw-slideshow2__arrow--prev');
    const nextBtn = root.querySelector('.sw-slideshow2__arrow--next');
    const dots = Array.from(root.querySelectorAll('.sw-slideshow2__dot'));

    let index = Math.max(
      slides.findIndex((slide) => slide.classList.contains('is-active')),
      0
    );

    const goTo = (newIndex) => {
      const total = slides.length;
      index = ((newIndex % total) + total) % total;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
    };

    const next = () => goTo(index + 1);
    const prev = () => goTo(index - 1);

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    // Autoplay, con pausa al pasar el mouse o enfocar controles
    const autoplay = root.dataset.autoplay === 'true';
    const speed = (parseFloat(root.dataset.autoplaySpeed) || 6) * 1000;
    let timer = null;

    const start = () => {
      if (!autoplay) return;
      stop();
      timer = setInterval(next, speed);
    };

    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    if (autoplay) {
      start();
      root.addEventListener('pointerenter', stop);
      root.addEventListener('pointerleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
    }

    // Navegación por teclado
    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') prev();
      if (event.key === 'ArrowRight') next();
    });

    goTo(index);
  });
})();
